module.exports = __webpack_public_path__ + "static/media/crown.750b9b52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Panels/SharedComponents/Product/crown.svg
// module id = 448
// module chunks = 0